module.exports = __webpack_public_path__ + "static/media/expire.d26b0465.svg";